import styled from "styled-components";

export const Container = styled.div`
	width: 23rem;
	height: 75vh;
	margin: 1rem;
	
	background-color: white;
	position: relative;

	border-radius: 20px;
	`

export const ImgContainer = styled.div`
	width: 100%;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	height: 50%;

	display: flex;
	justify-content: center;
	align-items: flex-end;

	background-image: url(${props => props.bgImage});
	background-size: cover;
	background-position: center top;
	background-repeat: no-repeat;
	border-bottom: 1px solid lightgrey;
`

export const TechnologyContainer = styled.div`
	width: 90%;
	height: 15%;

	position: absolute;
	top: 42%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	border: 1px solid black;
	border-radius: 20px;

	display: none;
`

export const Technology = styled.img`
	width: 3rem;
	height: 80%;
	margin: 0.5rem;
`

export const TextContainer = styled.div`
	padding: 10px;
	/* padding-top: 35px; */
	width: 100%;
	height: 35%;
`

export const Heading = styled.h3`
	font-size: 1.5rem;
	color: black;
	
	@media (max-width: 460px){
		font-size: 1rem;
	}
`

export const Text = styled.p`
	padding: 6px 0;
	color: #727272;
	height: inherit;
	font-size: 1rem;
	line-height: 25px;
`

export const InfoContainer = styled.div`
	height: 15%;
	width: 100%;

	display: flex;
	justify-content: space-evenly;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
`

export const OwnerContainer = styled.div`
	width: 50%;
	height: 90%;

	display: flex;
	justify-content: space-evenly;
	align-items: center;

	color: black !important;
`

export const ProjectLinkBtnContainer = styled.div`
	width: 40%;
	height: 90%;
	
	display: flex;
	justify-content: center;
	align-items: center;

`

export const ProjectLinkBtn = styled.div`
	width: 100%;
	height: 70%;
	background-color: #34a853;
	color: white;
	font-weight: bold;
	border-radius: 20px;
	font-size: 1.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
	
	@media (max-width: 460px){
		font-size: 1rem;
	}
`

export const LinkTag = styled.a`
	width: 90%;
	height: 100%;
	border-radius: 20px;
	color: black;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;

	&:hover ${ProjectLinkBtn}{
		box-shadow: 5px 5px 10px 0px black;
	}
`

export const OwnerPicContainer = styled.div`
	width: 3.5rem;
	height: 3.5rem;

	border-radius: 10px;

	background-image: url(${props => props.photo});
	background-size: 100% 100%;
	background-position: center;
	background-repeat: no-repeat;
`

export const OwnerNameSocialContainer = styled.div`
	width: 60%;
	height: 90%;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
`

export const OwnerName = styled.span`
	font-size: 1rem;
	font-weight: 300;
	font-style: italic;
	
	@media (max-width: 460px){
		font-size: 0.9rem;
	}
`

export const OwnerSocialHandle = styled.div`
	width: 100%;
	height: 50%;

	display: flex;
	justify-content: space-evenly;
	align-items: center;
`

export const I = styled.i`
	padding: 0 4px;
`

export const Href = styled.a`
	color: black;
	cursor: pointer;
	border-radius: 20px;

	&:hover{
		color: white;
		background-color: black;
	}
`

export const Social = styled.img`
	width: 30%;
	height: 60%;
`

	